import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert, Modal,FlatList, TextInput, ScrollView } from 'react-native'
import { useNavigation } from '@react-navigation/native';
import { ChevronDoubleLeftIcon, MagnifyingGlassIcon as GlassIcon } from "react-native-heroicons/solid";
import { inline } from 'react-native-web/dist/cjs/exports/StyleSheet/compiler';
import ResourceButton from './ResourceButtons/ResoruceButton';
import { useTailwind } from 'tailwind-rn';

import { database } from '../database/firebase';
import { collection, doc, getDoc, getDocs, addDoc, query, orderBy, onSnapshot } from 'firebase/firestore';

const ResourceList = (  ) => {

  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [dataSitua, setDataSitua] = useState();


  const tailwind = useTailwind();


  async function getMain() {
    console.log("Database");
    console.log(database);

    console.log("get the data")
    const docRef = doc(database, "Main", "ZWgK3F0PRUswbSPrwifq");
    const docSnap = await getDoc(docRef);
    console.log("data is")
    console.log(docSnap);
    console.log(docSnap.data())

    console.log("Situaciones2: ");
    const collRef = collection(database, "Situaciones2") 
    const query1 = query( collection(database, "Situaciones2") );
    const query1snap = await getDocs(query1);

    console.log(query1);
    console.log(query1snap);

    let listaSitua = []

    query1snap.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      //console.log(doc.id, " => ", doc.data());
      //console.log(doc)
      //console.log(doc.data()["codigo"])
      let situa = {};

      situa["codigo"] = doc.data()["codigo"];
      situa["nombre"] =  doc.data()["titulo"];
      situa["ejes"] = doc.data()["ejes"];
      situa["tags"] =  doc.data()["etiquetas"];
      situa["version"] =  doc.data()["version"];

      //console.log(situa);

      listaSitua.push(situa)

    });

    console.log(collRef);
    //console.log(listaSitua);
    setDataSitua(listaSitua);

    setData(docSnap.data());
    //setData(docSnap.data())

  }

  useEffect(() => {

    getMain().then(setLoading(false));

  }, []);


  return (
    <ScrollView style={ tailwind("bg-white") }>
      <Text>Versión web: </Text>
      <Text/>
      <View style={styles.searchview}>
        <GlassIcon style={{height:30}}/>
        <TextInput style={{paddingLeft:12, marginLeft:12}}  placeholder="Curso... "/>
      </View>
      
      <Text>Version: {data["version"]} </Text>
      <Text> Mis Recursos :</Text>
      <Text/>

      {isLoading ? <Text>Loading...</Text> : 
        <FlatList
          data={dataSitua} //data["situaciones"]
          renderItem={ ({item: resource}) => (
            <ResourceButton
              codigo = {resource["codigo"]}
              nombre = {resource["nombre"]}
              ejes = {resource["ejes"]}
              tags = {resource["tags"]}
              url = {resource["location"]}
              version = {resource["version"]}
            />
          )}
        />
      }
    </ScrollView>
  );
    
};
  
  const styles = StyleSheet.create({

    searchview: {
      padding: 6,
      flexDirection: 'row',
      flexGrow: 1,
      backgroundColor: '#C4C4C6',
      maxWidth: 232,
      height: Platform.OS != 'web' ? 44 : 42,
    }
  });
  
  export default ResourceList